(function () {
  // --------------------------------------------------------------------
  // Personalization toggle show/hide + inject/remove hidden bundle inputs
  // --------------------------------------------------------------------
  function getForm(container) {
    const formId = container?.dataset.productFormId;
    if (formId) {
      const byId = document.getElementById(formId);
      if (byId) return byId;
    }
    // Fallback 1: the bundle might be nested inside the actual <form>
    const nestedForm = container?.closest('form');
    if (nestedForm) return nestedForm;
    // Fallback 2: grab the page's add-to-cart form directly
    return document.querySelector('form[is="product-form"]') || null;
  }

  // A product page can render more than one add-to-cart form for the same
  // product (e.g. the main form + a sticky-bar duplicate). We don't know
  // which one the customer will actually submit, so bundle inputs must be
  // injected into ALL of them, and submit validation must apply to ALL of
  // them — otherwise whichever form isn't "the" resolved form silently
  // misses the bundle tag or skips validation.
  function getAllForms(container) {
    const forms = Array.from(document.querySelectorAll('form[is="product-form"]'));
    if (forms.length > 0) return forms;
    const single = getForm(container);
    return single ? [single] : [];
  }

  document.addEventListener('submit', (event) => {
    const container = document.querySelector('.personalization-bundle');
    if (!container) return;

    if (!getAllForms(container).includes(event.target)) return;

    const toggle = container.querySelector('.js-personalization-toggle');
    if (!toggle?.checked) return;

    const nameInput = container.querySelector('.js-personalization-name');
    const value = (nameInput?.value || '').trim();

    if (!value) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showPersonalizationError(nameInput, 'Please enter initials to personalize this item.');
      nameInput?.focus();
    }
  }, true); // capture: true — must run before ProductForm's own submit handler

  function injectBundleInputs(container, timestamp) {
    const forms = getAllForms(container);
    if (!forms.length) return;

    removeBundleInputs(container); // clean slate first

    forms.forEach((form) => {
      const timestampInput = document.createElement('input');
      timestampInput.type = 'hidden';
      timestampInput.name = 'properties[_bundleTimestamp]';
      timestampInput.value = timestamp;
      timestampInput.className = 'js-bundle-hidden-input';

      const roleInput = document.createElement('input');
      roleInput.type = 'hidden';
      roleInput.name = 'properties[_bundleRole]';
      roleInput.value = 'main';
      roleInput.className = 'js-bundle-hidden-input';

      // Append directly INSIDE the actual <form> element — this guarantees
      // inclusion in FormData(form) regardless of DOM position of the
      // personalization block relative to the form, and survives any
      // section/AJAX re-renders as long as we re-inject on toggle.
      form.appendChild(timestampInput);
      form.appendChild(roleInput);
    });

    container.dataset.activeTimestamp = timestamp;
  }

  function removeBundleInputs(container) {
    getAllForms(container).forEach((form) => {
      form.querySelectorAll('.js-bundle-hidden-input').forEach((el) => el.remove());
    });
    delete container.dataset.activeTimestamp;
  }

  function toggleNameInput(event) {
    if (!event.target.classList.contains('js-personalization-toggle')) return;
    const container = event.target.closest('.personalization-bundle');
    const wrapper = container?.querySelector('.js-personalization-name-wrapper');
    const nameInput = container?.querySelector('.js-personalization-name');
    if (!container || !wrapper || !nameInput) return;

    wrapper.hidden = !event.target.checked;
    nameInput.disabled = !event.target.checked;

    if (!event.target.checked) {
      nameInput.value = '';
      clearPersonalizationError(nameInput);
      removeBundleInputs(container);
    } else {
      nameInput.focus();
      injectBundleInputs(container, Date.now().toString());
    }
  }
  document.addEventListener('change', toggleNameInput);

  function getErrorEl(input) {
  return input.closest('.personalization-bundle')?.querySelector('.js-personalization-error');
}

function showPersonalizationError(input, message) {
  const errorEl = getErrorEl(input);
  if (errorEl) {
    errorEl.textContent = message;
    errorEl.hidden = false;
  }
}

function clearPersonalizationError(input) {
  const errorEl = getErrorEl(input);
  if (errorEl) {
    errorEl.textContent = '';
    errorEl.hidden = true;
  }
}

document.addEventListener('input', (event) => {
  if (!event.target.classList.contains('js-personalization-name')) return;
  const input = event.target;
  const max = parseInt(input.getAttribute('maxlength') || '4', 10);

  if (/[^a-zA-Z]/.test(input.value)) {
    input.value = input.value.replace(/[^a-zA-Z]/g, '');
    showPersonalizationError(input, 'Only letters are allowed.');
  } else {
    clearPersonalizationError(input);
  }

  input.value = input.value.toUpperCase();

  if (input.value.length > max) {
    input.value = input.value.slice(0, max);
  }
});

  // --------------------------------------------------------------------
  // Gather what the customer opted into
  // --------------------------------------------------------------------
  function readPersonalizationContext() {
    const container = document.querySelector('.personalization-bundle');
    if (!container) return null;
    const toggle = container.querySelector('.js-personalization-toggle');
    if (!toggle?.checked) return null;

    const nameInput = container.querySelector('.js-personalization-name');
    const bundleVariantId = container.dataset.bundleVariantId;
    const timestamp = container.dataset.activeTimestamp;
    if (!bundleVariantId || !timestamp) return null;

    const max = parseInt(nameInput?.getAttribute('maxlength') || '4', 10);
    const name = (nameInput?.value || '').trim().slice(0, max);

    return {
      variantId: bundleVariantId,
      timestamp,
      extraProperties: name ? { 'Personalized For': name } : {},
    };
  }

  function readAddonContext() {
    return Array.from(document.querySelectorAll('.js-addon-toggle:checked')).map((checkbox) => ({
      variantId: checkbox.dataset.addonVariantId,
      properties: { 'Add-on': checkbox.dataset.addonTitle || '' },
    }));
  }

  function readSubmittedQuantity() {
    const container = document.querySelector('.personalization-bundle');
    const form = getForm(container);
    const quantityInput = form?.querySelector('[name="quantity"]');
    const parsed = parseInt(quantityInput?.value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  }

  // --------------------------------------------------------------------
  // After the MAIN product add-to-cart request completes:
  // - The main line ALREADY carries _bundleTimestamp/_bundleRole (if
  //   personalization was checked) because those hidden inputs were
  //   injected directly into the product form before submission.
  // - Add-ons are added as fully independent items (no properties).
  // - Personalization is added tagged with the SAME timestamp, role
  //   'child', using the actual submitted quantity.
  // --------------------------------------------------------------------
  async function addLinkedProducts() {
    const personalization = readPersonalizationContext();
    const addons = readAddonContext();

    if (!personalization && addons.length === 0) return;

    const quantity = readSubmittedQuantity();

    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:start', { bubbles: true })
    );

    try {
      const itemsToAdd = [];

      addons.forEach((addon) => {
        itemsToAdd.push({
          id: addon.variantId,
          quantity,
        });
      });

      if (personalization) {
        itemsToAdd.push({
          id: personalization.variantId,
          quantity,
          properties: {
            _bundleTimestamp: personalization.timestamp,
            _bundleRole: 'child',
            ...personalization.extraProperties,
          },
        });
      }

      if (itemsToAdd.length > 0) {
        const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd }),
        });

        if (!addResponse.ok) throw new Error('Failed to add linked products');
      }

      // Reset the toggle + hidden inputs so the NEXT plain add-to-cart
      // doesn't accidentally carry stale bundle properties.
      const container = document.querySelector('.personalization-bundle');
      if (container) {
        const toggle = container.querySelector('.js-personalization-toggle');
        const wrapper = container.querySelector('.js-personalization-name-wrapper');
        const nameInput = container.querySelector('.js-personalization-name');
        if (toggle) toggle.checked = false;
        if (wrapper) wrapper.hidden = true;
        if (nameInput) {
          nameInput.value = '';
          nameInput.disabled = true;
        }
        removeBundleInputs(container);
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.error('Bundle linking: failed to add linked products', err);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  document.addEventListener('variant:add', (event) => {
    const items = event.detail?.items;
    const mainItem = Array.isArray(items) ? items[0] : items;
    if (!mainItem?.key) return;
    addLinkedProducts();
  });

  // --------------------------------------------------------------------
  // Reconciliation: only cascades when the MAIN item is removed.
  // --------------------------------------------------------------------
  let isReconciling = false;

  async function reconcileBundles() {
    if (isReconciling) return;
    isReconciling = true;

    try {
      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      const mainTimestampsPresent = new Set();
      const childrenByTimestamp = {};

      cart.items.forEach((item) => {
        const timestamp = item.properties && item.properties._bundleTimestamp;
        const role = item.properties && item.properties._bundleRole;
        if (!timestamp || !role) return;

        if (role === 'main') {
          mainTimestampsPresent.add(timestamp);
        } else if (role === 'child') {
          childrenByTimestamp[timestamp] = childrenByTimestamp[timestamp] || [];
          childrenByTimestamp[timestamp].push(item.key);
        }
      });

      const updates = {};
      Object.entries(childrenByTimestamp).forEach(([timestamp, keys]) => {
        if (!mainTimestampsPresent.has(timestamp)) {
          keys.forEach((key) => { updates[key] = 0; });
        }
      });

      if (Object.keys(updates).length === 0) return;

      await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.error('Bundle linking: reconciliation failed', err);
    } finally {
      isReconciling = false;
    }
  }

  document.addEventListener('cart:change', () => {
    setTimeout(reconcileBundles, 300);
  });
})();
document.addEventListener('change', (event) => {
  if (!event.target.classList.contains('js-personalization-variant-option')) return;

  const container = event.target.closest('.personalization-bundle');
  if (!container) return;

  const optionSelects = Array.from(container.querySelectorAll('.js-personalization-variant-option'));
  const selectedValues = optionSelects.map((select) => select.value);

  const variantSelect = container.querySelector('.js-personalization-variant-id');
  const matchingOption = Array.from(variantSelect?.options || []).find((option) => {
    return [option.dataset.option1, option.dataset.option2, option.dataset.option3]
      .filter(Boolean)
      .every((value, index) => value === selectedValues[index]);
  });

  if (matchingOption && !matchingOption.disabled) {
    container.dataset.bundleVariantId = matchingOption.value;
  }
});
